<template>
    <SubscriptionRequiredDialog
        v-if="account"
        :account="account"
        feature-not-enabled
        @close="closeDialog"
    />
</template>

<script>
import {computed} from "@vue/composition-api";
import AppModule from "../../store/modules/app";
import SubscriptionRequiredDialog from "@/views/Subscription/SubscriptionRequiredDialog";

export default {
    name: "FeatureNotEnabledDialog",
    components: {
        SubscriptionRequiredDialog
    },
    setup() {
        const appModule = AppModule();

        const account = computed(() => {
            return appModule.featureNotEnabledForCompany.value;
        })

        const closeDialog = function () {
            appModule.closeFeatureNotEnabled();
        };

        return {
            closeDialog,
            account
        };
    }
};
</script>
